import { render, staticRenderFns } from "./OntologyTree.vue?vue&type=template&id=368f537b&scoped=true"
import script from "./OntologyTree.vue?vue&type=script&lang=js"
export * from "./OntologyTree.vue?vue&type=script&lang=js"
import style0 from "./OntologyTree.vue?vue&type=style&index=0&id=368f537b&prod&scoped=true&lang=css"
import style1 from "./OntologyTree.vue?vue&type=style&index=1&id=368f537b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f537b",
  null
  
)

export default component.exports